import SortTilesAsc from './SortTilesAsc'

export default SortTilesAsc
// eslint-disable-next-line import/export
export * from './SortTilesAsc'
